import type {MySongsPageReducer} from "../../mySongsPage.types";
import {isDefined, isUndefined} from "../../../../../../util/is-type";
import type {ISongDetailsResponseSong} from "../../../../../../client/models/songs/ISongDetailsResponse";

export const updateSongDetailsLessonUserLibraryAndFavoriteReducer: MySongsPageReducer<{lessonId: number; isInLibrary: boolean; isFavorited: boolean;}> = (store, action) => {
  const {
    isFavorited,
    isInLibrary,
    lessonId,
  } = action.payload;

  if (isUndefined<ISongDetailsResponseSong>(store.selectedSong?.details)){
    // no details loaded, no lessons that can be updated
    return store;
  }

  // make sure we have the lesson details to update
  const hasLessonToUpdate = isDefined(
    store
      .selectedSong
      ?.details
      ?.lessons
      .find(({id}) => id === lessonId));

  if (!hasLessonToUpdate){
    // no need to update state, return unchanged
    return store;
  }

  const updatedLessons = [
    ...(store.selectedSong?.details?.lessons ?? []),
  ]
    .map((lesson) => {
      if (lesson.id !== lessonId) {
        return lesson;
      }

      return {
        ...lesson,
        userDetails: {
          ...lesson.userDetails,
          isInLibrary,
          isFavorited: (isInLibrary && isFavorited),
        }
      };
    });

  return {
    ...store,
    selectedSong: {
      ...store.selectedSong,
      details: store.selectedSong?.details ? {
        ...store.selectedSong?.details,
        lessons: updatedLessons ? updatedLessons : [],
      } : undefined,
    },
  };
}
